@let f = form();
<div class="pt-16">
    <p class="text-16 leading-27 tracking-[0.32px] text-black lg:tracking-unset">
        Wir reservieren Ihnen gerne Ihr Wunschfahrzeug. Unser Verkaufspersonal wird sich bezüglich Ihrer
        Reservierungsanfrage kurzfristig bei Ihnen melden. Die Anfrage zur Reservierung ist für Sie kostenfrei und
        unverbindlich.  
    </p>

    <lib-distribution-contact-template
        [form]="f"
        (formClicked)="trackingStart()"
        (submitClicked)="submitClicked.emit()"
    />
</div>
